
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
@Component
export default class OrderTableHead extends Vue {
  @Prop({ type: Boolean, default: true }) loading;
  @Prop({ type: Object, default: () => {} }) data;

  get valObj() {
    const { data } = this;
    return data && Object.keys(data).forEach(key => data[key] || "-");
  }
}
